// Commented by Akhil - Redesigned AdminNavbar for Sirifarms
// Changes: Logo updated, search removed, mail/notifications removed, profile icon with functional dropdown
import * as React from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/Logout';
import Avatar from '@mui/material/Avatar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../Redux/Auth/Action';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';

export default function AdminNavbar({ handleSideBarViewInMobile }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { auth } = useSelector((store) => store);

  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleGoToHomepage = () => {
    handleMenuClose();
    navigate('/');
  };

  const handleLogout = () => {
    handleMenuClose();
    dispatch(logout());
    navigate('/');
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      PaperProps={{
        elevation: 3,
        sx: {
          mt: 1.5,
          minWidth: 180,
          '& .MuiMenuItem-root': {
            px: 2,
            py: 1.5,
          },
        },
      }}
    >
      {/* Show user info at top of menu */}
      {auth.user && (
        <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid #eee' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            {auth.user.firstName} {auth.user.lastName}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {auth.user.email}
          </Typography>
        </Box>
      )}
      <MenuItem onClick={handleGoToHomepage}>
        <ListItemIcon>
          <HomeIcon fontSize="small" />
        </ListItemIcon>
        Go to Homepage
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleLogout} sx={{ color: 'error.main' }}>
        <ListItemIcon>
          <LogoutIcon fontSize="small" sx={{ color: 'error.main' }} />
        </ListItemIcon>
        Logout
      </MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + isLargeScreen,
          backgroundColor: '#6B8E23' // organic-green to match homepage navbar
        }}
      >
        <Toolbar>
          {/* Mobile menu icon */}
          {!isLargeScreen && (
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="open drawer"
              sx={{ mr: 2 }}
              onClick={handleSideBarViewInMobile}
            >
              <MenuIcon />
            </IconButton>
          )}

          {/* Sirifarms Logo - Commented by Akhil */}
          <Box
            component="img"
            src="/siri_farms.png"
            alt="Siri Farms"
            sx={{
              height: 50,
              width: 'auto',
              cursor: 'pointer',
              mr: 2,
            }}
            onClick={() => navigate('/admin')}
          />

          {/* Sirifarms Title - Commented by Akhil */}
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ display: { xs: 'none', sm: 'block' }, fontWeight: 600 }}
          >
            Sirifarms
          </Typography>

          {/* Spacer */}
          <Box sx={{ flexGrow: 1 }} />

          {/* Profile Icon - Only icon remaining after removing search, mail, notifications */}
          <IconButton
            size="large"
            edge="end"
            aria-label="account of current user"
            aria-controls={menuId}
            aria-haspopup="true"
            onClick={handleProfileMenuOpen}
            color="inherit"
          >
            {auth.user ? (
              <Avatar
                sx={{
                  width: 32,
                  height: 32,
                  bgcolor: '#F5F5DC',
                  color: '#1A1A1A',
                  fontSize: '0.9rem',
                  fontWeight: 600
                }}
              >
                {auth.user.firstName?.[0]?.toUpperCase() || 'A'}
              </Avatar>
            ) : (
              <AccountCircle />
            )}
          </IconButton>
        </Toolbar>
      </AppBar>
      {renderMenu}
    </Box>
  );
}